<template>
<ValidationObserver ref="observer">
  <form ref="add_spare_part_master_form" @submit.prevent="addSparePartMaster">
    <md-card>
      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Spare Part Master
        </h4>
      </md-card-header> -->
      <br>
      <md-card-content>
        <div class="md-layout md-glutter">
          <div class="md-layout-item md-size-100 md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
           <span style="color:brown">Spare Part Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="code" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Part/Material Code</label>
                <md-input v-model="spare_part_master_code" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_code" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        <!-- </div>

        <div class="md-layout"> -->
          <div class="md-layout-item md-size-100 md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Part/Material Name</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Part/Material Name</label>
                <md-input v-model="spare_part_master_name" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        <!-- </div>

        

        <div class="md-layout"> -->
          <div class="md-layout-item md-size-50 md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Unit</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="unit" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Unit</label>
                <md-input v-model="spare_part_master_unit" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_unit" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          <!-- </div>
          <div class="md-layout-item md-small-size 100"> -->
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Unit Price</span><span style="color:red">*</span>
            </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <validation-provider rules="unitprice" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Unit Price</label>
                <md-input v-model="spare_part_master_unit_price" type="text" v-on:keypress="NumbersOnly" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_unit_price" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>

        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Quantity Procurement</span>
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="spare_part_master_quantity_procurement" type="text" v-on:keypress="NumbersOnly"/>
              <validation-error :errors="apiValidationErrors.spare_part_master_quantity_procurement" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Quantity Nota Bahan</span>
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="spare_part_master_quantity_nota_bahan" type="text" v-on:keypress="NumbersOnly"/>
              <validation-error :errors="apiValidationErrors.spare_part_master_quantity_nota_bahan" />
            </md-field>
          </div>
        </div> -->

        <!-- <div class="md-layout">
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Type</span>
          </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field class="md-invalid">
                <label for="">Type</label>
                <md-select v-model="spare_part_master_type" >
                  <md-option value="1">Spare Part</md-option>
                  <md-option value="2">Material</md-option>
                  <md-option value="3">Not Spare Part & Material</md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.spare_part_master_type" />
              </md-field>
            </div>
          <!-- </div>
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Category</span>
          </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field class="md-invalid">
                <label for="">Category</label>
                <md-select v-model="spare_part_master_category" >
                  <md-option value="1">Fast Moving</md-option>
                  <md-option value="2">Slow Moving</md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.spare_part_master_category" />
              </md-field>
            </div>
        <!-- </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Spare Part Alert Price</span>
          </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field class="md-invalid">
                <label for="">Part/Material Alert Price</label>
                <md-input v-model="spare_part_master_alert_price" type="text" v-on:keypress="NumbersOnly"/>
                <validation-error :errors="apiValidationErrors.spare_part_master_alert_price" />
              </md-field>
            </div>
          <!-- </div>
          <div class="md-layout-item md-small-size 100"> -->
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Spare Part Trace Hold</span>
            </label> -->
            
          </div>
          
      

      </md-card-content>
      <md-card-header>
        
      <span>Threshold</span>
      </md-card-header>
      <md-card-content>
        <div class="md-layout md-glutter">
            <div  
            v-for="(item, index) in spare_part_master_threshold_list"
            :key="index"
            class="md-layout-item md-size-50 md-small-size-100">
                <md-field class="md-invalid">
                  <label for="">{{item.warehouse_name}} Threshold</label>
                  <md-input v-model="item.threshold" type="text" v-on:keypress="NumbersOnly"/>
                  <validation-error :errors="apiValidationErrors.spare_part_master_threshold" />
                </md-field>
              </div>


          </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import { extend , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import formMixin from "@/mixins/form-mixin";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// validasi pesan error required field
extend('name', {
  ...required,
  message: 'Part/Material Name field is required'
});
extend('code', {
  ...required,
  message: 'Part/Material Code field is required'
});
extend('unit', {
  ...required,
  message: 'Part/Material Unit field is required'
});
extend('unitprice', {
  ...required,
  message: 'Part/Material Unit Price field is required'
});
export default {
  name: "add-service-categories",

  props: {
    data: Object
  },

  components: {ValidationError, ValidationObserver},

  mixins: [formMixin],

  data: () => ({ 
    list_warehouse: null,
    spare_part_master_code: null,
    spare_part_master_name: null,
    // spare_part_master_quantity_procurement: null,
    spare_part_master_unit: null,
    spare_part_master_unit_price: null,
    // spare_part_master_quantity_nota_bahan: null,
    spare_part_master_type: null,
    spare_part_master_category: null,
    spare_part_master_alert_price: null,
    spare_part_master_threshold_list: [],
      
  }),
    
  async created() {
      await this.$store.dispatch("workshop_warehouse/list")
      this.list_warehouse = await this.$store.getters["workshop_warehouse/list"];
      var arr_threshold = []
      this.list_warehouse.forEach(function(warehouse) {
        arr_threshold.push({
            warehouse_name: warehouse.warehouse_name,
            warehouse_id: warehouse.id,
            threshold: null,
        });
      });
      this.spare_part_master_threshold_list = arr_threshold;
    },
  methods: {
    // async getLastNo(){
    //      await this.$store.dispatch("workshop_spare_part_master/last_no")
    //      this.spare_part_master_code =  await this.$store.getters["workshop_spare_part_master/spare_part_master"]
           
    // },
    

    // fungsi tombol direct ke list spare part master
    backtoList(id) {
      this.$router.replace({ name: 'List Spare Part Master' })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    // validasi add data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addSparePartMaster()
        }
      });
    },
    
    // fungsi add spare part master
    async addSparePartMaster() {
      const data = {
        type: "workshop_spare_part_masters", 
        spare_part_master_code: this.spare_part_master_code,
        spare_part_master_name: this.spare_part_master_name,
        // spare_part_master_quantity_procurement: this.spare_part_master_quantity_procurement,
        spare_part_master_unit: this.spare_part_master_unit,
        spare_part_master_unit_price: this.spare_part_master_unit_price,
        // spare_part_master_quantity_nota_bahan	: this.spare_part_master_quantity_nota_bahan,
        spare_part_master_type: this.spare_part_master_type,
        spare_part_master_category: this.spare_part_master_category,
        spare_part_master_alert_price: this.spare_part_master_alert_price,
        spare_part_master_threshold_list: this.spare_part_master_threshold_list
      }
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_spare_part_master/add", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // kembali ke list spare part master
        await this.$router.replace({name: 'List Spare Part Master'});
      } catch (e) {
        // panggil alert error
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

    }
  }
};
</script>
<style scoped>

.md-layout-item{
  margin-top:10px;
}
</style>
